import styles from './CountdownAction.module.css';

interface ICountdownAction {
  countdownString: string;
}

export function CountdownAction({ countdownString }: ICountdownAction) {
  return (
    <>
      <div className="text-center mb-3">
        <span className="fw-semibold">Corra! Restam apenas:</span>
      </div>
      <div className={`${styles.contentainerCountdown} p-3`}>
        <div className="d-flex align-items-center">
          <i className="material-icons-outlined me-3 color-text fs-1">timer</i>
          <div className="d-flex flex-column align-items-center container-fluid">
            <span className="fs-3 fw-semibold">
              {countdownString.split('d')[0]}
            </span>
            <span className={`text-center ${styles.tinyText}`}>Dias</span>
          </div>
          <div className="d-flex flex-column align-items-center container-fluid">
            <span className="fs-3 fw-semibold">
              {countdownString.split(/d(.*?)h/)[1]}
            </span>
            <span className={`text-center ${styles.tinyText}`}>Horas</span>
          </div>
          <div className="d-flex flex-column align-items-center container-fluid">
            <span className="fs-3 fw-semibold">
              {countdownString.split(/h(.*?)m/)[1]}
            </span>
            <span className={`text-center ${styles.tinyText}`}>Minutos</span>
          </div>
        </div>
      </div>
    </>
  );
}
